import { COUNTRIES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(COUNTRIES);
    }
}